import { Modal, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

import deleteIcon from '@/assets/pink-one/delete.svg';

import type { NoteItemData } from '../../types';
import styles from './index.module.scss';

const { Text, Paragraph } = Typography;
const { confirm } = Modal;

export const NoteItem = ({ author, createdTime, content }: NoteItemData) => {
  const showDeleteConfirm = () => {
    confirm({
      title: '確定刪除備註？',
      content: '刪除後將無法復原',
      centered: true,
      onOk() {
        console.log('刪除備註');
        // TODO: 邏輯待寫
      },
    });
  };

  return (
    <li className={styles.noteItem}>
      <div className={styles.noteHeaderBox}>
        <div className={styles.noteHeader}>
          <Text strong>{author}</Text>
          <button onClick={showDeleteConfirm}>
            <img src={deleteIcon} alt="delete icon" />
          </button>
        </div>

        <Text type="secondary">
          {dayjs(createdTime).format('YYYY/MM/DD HH:mm')}
        </Text>
      </div>

      <Paragraph className={styles.noteContent}>{content}</Paragraph>
    </li>
  );
};
